@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.map-order-import-body-content {
  height: 485px;
  overflow: auto;
  padding: 15px;
}

.map-order-import-sub-heading {
  display: flex;
  align-items: center;
  line-height: 0;
  margin-bottom: 8px;
  margin-top: 0;
}

.loading-indicator {
  height: 800px;
}

.map-order-item-icon {
  svg {
    width: 35px;
    margin-left: -7px;
    fill: @map-order-import-modal--fill-color;
  }
}

.map-order-import-modal-body {
  height: 543px;
}

.fixed-modal-body-bottom {
  height: 55px;
  min-height: 58px;
  background-color: @map-order-import-modal--body--background-color;
  display: flex;
  padding: 0 15px;
}

.modal-body-bottom-first-column {
  flex-basis: 100%;
  padding: 8px 0;
}

.modal-body-bottom-second-column {
  flex-basis: 75%;
  font-size: 14px;
  padding: 2px 10px;
  color: @map-order-import-modal--body--text-color;
}

.order-import-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.start-import-button-text {
  display: inline-block;
  margin-left: 10px;
}

.map-order-import-error {
  padding: 5px 15px;
  margin-bottom: 18px;
}

.icon {
  padding: 8px;
}
